import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ChevronRightIcon, Radio, tokens } from '@treams/treams-ui';

const QuestionLabel = styled.div`
	margin-top: ${tokens.gap.group}px;
	color: ${tokens.text.secondary};
	font-family: ${tokens.typography.fontFamily};
	font-size: ${tokens.typography.sizes.body}px;
	font-weight: ${tokens.typography.weights.medium};
	line-height: ${tokens.typography.lineHeights.body};
`;

const Question = styled.h2`
	margin: ${tokens.gap.element}px 0 0;
	color: ${tokens.text.primary};
	font-family: ${tokens.typography.fontFamily};
	font-size: ${tokens.typography.sizes.h2}px;
	font-weight: 500;
	line-height: ${tokens.typography.lineHeights.heading};
`;

const Options = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${tokens.gap.element}px;
	margin-top: ${tokens.gap.group}px;
`;

const OptionRow = styled.div`
	position: relative;
`;

const OptionCard = styled(Radio.Card)`
	width: 100%;
	padding-right: ${tokens.gap.element * 2 + 16}px;
`;

const OptionChevron = styled.div`
	position: absolute;
	right: ${tokens.gap.element}px;
	top: 50%;
	transform: translateY(-50%);
	line-height: 0;
	color: ${tokens.text.secondary};
	pointer-events: none;

	svg {
		display: block;
		width: 16px;
		height: 16px;
	}
`;

export default function TalentReviewPlacementHelpQuestion(props: {
	index: number;
	axisLabel: string;
	question: string;
	options: { id: string; label: string }[];
	selected?: string;
	onSelect: (answerID: string) => void;
}) {
	const { t } = useTranslation();

	return (
		<>
			<QuestionLabel>
				{t('talentReviews.v2.placementHelp.questionLabel', {
					current: props.index + 1,
					topic: props.axisLabel,
				})}
			</QuestionLabel>
			<Question>{props.question}</Question>
			<Options
				role="radiogroup"
				aria-label={t('talentReviews.v2.placementHelp.question', {
					current: props.index + 1,
				})}
			>
				{props.options.map((answer) => (
					<OptionRow key={answer.id}>
						<OptionCard
							checked={props.selected === answer.id}
							onChange={() => props.onSelect(answer.id)}
							title={answer.label}
						/>
						<OptionChevron aria-hidden>
							<ChevronRightIcon />
						</OptionChevron>
					</OptionRow>
				))}
			</Options>
		</>
	);
}
